import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import FAQSection from './components/FAQSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />

        <ContactSection />

        <TopicsSection />

        <AboutSection />

        <CarouselSection />

        <RankingSection />

        <AppSection />

        <FeaturesSection />

        <IndexSection />

        <CommentsSection />

        <MediaSection />

        <CardsSection />

        <FAQSection />

        <UpdatesSection />
      </main>

      <Footer />
    </div>
  );
}